module.exports = __webpack_public_path__ + "img/环境监测.7664c1af.png";